/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react';
import { SVGProps } from 'react';

const Eye = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={22}
    height={18}
    viewBox="0 0 22 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="Eye">
    <path
      d="M11 0c5.392 0 9.878 3.88 10.819 9-.94 5.12-5.427 9-10.819 9C5.608 18 1.122 14.12.181 9 1.121 3.88 5.608 0 11 0Zm0 16a9.005 9.005 0 0 0 8.777-7A9.005 9.005 0 0 0 2.223 9 9.005 9.005 0 0 0 11 16Zm0-2.5a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Zm0-2a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
      fill="currentColor"
    />
  </svg>
);

export default Eye;
